import type { Receipt } from "../api/cashier-types";

export function receiptDiscountSummary(
  receipt: Pick<Receipt, "discountMinor" | "discountBreakdown">,
  ar: boolean
) {
  const breakdown = receipt.discountBreakdown;
  const values = breakdown && [
    breakdown.promotionDiscountMinor,
    breakdown.couponDiscountMinor,
    breakdown.manualDiscountMinor
  ];
  const available = values && values.every(value => Number.isSafeInteger(value) && value >= 0)
    && values.reduce((total, value) => total + value, 0) === receipt.discountMinor;
  const rows = available && breakdown ? [
    { key: "promotion", label: ar ? "خصم العروض" : "Promotion discount", amountMinor: breakdown.promotionDiscountMinor },
    { key: "coupon", label: ar ? "خصم القسيمة" : "Coupon discount", amountMinor: breakdown.couponDiscountMinor },
    { key: "manual", label: ar ? "الخصم اليدوي" : "Manual discount", amountMinor: breakdown.manualDiscountMinor }
  ].filter(row => row.amountMinor > 0) : [];
  // Missing historical allocations retain only the original total. Never infer
  // components from today's order, coupon definition or payment methods.
  if (receipt.discountMinor > 0)
    rows.push({ key: "total", label: ar ? "إجمالي الخصومات" : "Total discounts", amountMinor: receipt.discountMinor });
  return { rows };
}
